import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProductsQuestionsService } from 'src/app/services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router, Event, NavigationEnd } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd';
import { removeEmptyQuery, sleep } from 'src/app/helpers';

@Component({
  selector: 'app-products-questions',
  templateUrl: './products-questions.component.html',
  styleUrls: ['./products-questions.component.scss'],
})
export class ProductsQuestionsComponent implements OnInit, OnDestroy {

  constructor(
    private questionService: ProductsQuestionsService,
    private notification: NzNotificationService,
    private router: Router
  ) {
    this.router.events
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          this.productId = window.location.href.split('/')[5];
          this.loadData2();
        }
      });
  }
  unsubscribe$ = new Subject<void>();

  pageIndex = 1;
  pageSize = 10;

  productId: string;

  // ================================list==================================//
  listOfAllData: any[] = [];
  total = 0;
  loading = true;
  hasMore: any;
  hasCollapse: any;

  openMessage(type: string, title: string, content: any) {
    return this.notification.create(type, title, content);
  }
  ngOnInit() {


    this.productId = window.location.href.split('/')[5];

    this.questionService.currentStatus
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((status) => {
        if (status) {
          this.pageIndex = 1;
          this.loadData();
          return;
        } else {
          this.loadData();
        }
      });
  }

  sleep(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async loadData(ms = 0) {
    console.log('321321');
    const query: any = {
      product_id: this.productId,
      offset: (this.pageIndex - 1) * this.pageSize,
      limit: this.pageSize,
    };

    removeEmptyQuery(query);
    await sleep(ms);
    this.loading = true;
    this.questionService
      .getAll(query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          console.log(res);
          this.loading = false;
          this.total = res.count;
          this.listOfAllData = res.responseList;

          // if (res.rows) {
          //   if (this.listOfAllData.length === this.total || this.total === 1) {
          //     this.hasMore = false;
          //   } else {
          //     this.hasMore = true;
          //   }
          //
          //   if (this.listOfAllData.length <= 1) {
          //     this.hasCollapse = false;
          //   } else {
          //     this.hasCollapse = true;
          //   }
          // }
        },
        (err) => {
          this.openMessage('error', 'Lỗi !!!', `${err}`);
          return;
        }
      );
  }

  async loadData2(ms = 0) {
    const query: any = {
      product_id: this.productId,
      offset: (this.pageIndex - 1) * this.pageSize,
      limit: this.pageSize,
    };

    removeEmptyQuery(query);
    await sleep(ms);

    this.loading = true;
    this.questionService
      .getAll(query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.loading = false;
          this.total = res.count;
          this.listOfAllData = res.responseList;
          console.log(res);
          if (this.listOfAllData ) {
            if (this.listOfAllData.length === this.total || this.total === 1) {
              this.hasMore = false;
            } else {
              this.hasMore = true;
            }

            if (this.listOfAllData.length <= 1) {
              this.hasCollapse = false;
            } else {
              this.hasCollapse = true;
            }
          }

          if (res.code === 1008) {
            this.openMessage('warning', 'Cảnh báo', `${res.message}`);
          }
        },
        (err) => {
          // this.openMessage('error', 'Lỗi !!!', `${err}`);
          return;
        }
      );
  }

  loadMore(type: string) {
    if (type === 'more') {
      this.hasMore = false;
      this.hasCollapse  = true;
      this.pageSize = this.pageSize + 10;
      this.loadData();
      return;
    }
    if (type === 'collapse') {
      this.hasMore = true;
      this.hasCollapse  = false;
      this.pageSize = this.pageSize - 10;
      if (this.pageSize < 1) {
        this.pageSize = 1;
      }
      this.loadData();
      return;
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
